// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2aY8R","content":"LoadingAlert_content__rD0jO"};